import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Typography } from 'antd';
import { useSearchParams } from 'react-router-dom';
import FinancialStatementReport, { type FinancialStatementKey } from '@/components/finance/report-document/FinancialStatementReport';

const { Title, Text } = Typography;

const TAB_KEYS: FinancialStatementKey[] = ['trial-balance', 'profit-loss', 'balance-sheet', 'cash-flow'];

export const FinancialReportsPage: React.FC = () => {
  const { t } = useTranslation('finance');
  const [searchParams, setSearchParams] = useSearchParams();
  const requested = searchParams.get('tab') as FinancialStatementKey | null;
  const active = TAB_KEYS.includes(requested as FinancialStatementKey) ? (requested as FinancialStatementKey) : 'trial-balance';

  const tabLabel = (key: FinancialStatementKey): string => {
    switch (key) {
      case 'trial-balance':
        return t('trialBalance');
      case 'profit-loss':
        return t('profitAndLoss');
      case 'balance-sheet':
        return t('balanceSheet');
      case 'cash-flow':
        return t('cashFlow');
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Title level={4} style={{ marginBottom: 4 }}>
        {t('financialStatements')}
      </Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
        {t('financialStatementsHint')}
      </Text>
      <Tabs
        activeKey={active}
        destroyInactiveTabPane
        onChange={(k) => setSearchParams({ tab: k }, { replace: true })}
        items={TAB_KEYS.map((key) => ({
          key,
          label: tabLabel(key),
          children: <FinancialStatementReport reportKey={key} />,
        }))}
      />
    </div>
  );
};

export default FinancialReportsPage;
